import React from "react"

// Styles
import "./Veranstaltungen.scss"

// Components
import Gallery from "./Gallery/Gallery"

// Data
import { veranstaltungenData } from "../../data/data"

const Veranstaltungen = () => {
  return (
    <section
      id="veranstaltungen"
      className="veranstaltungen-container my-container"
    >
      <h2 className="headline">Veranstaltungen</h2>
      <div className="text-wrapper">
        {veranstaltungenData.content.map(item => {
          if (item.id === 1) {
            return (
              <p key={item.id}>
                <span>{item.text.slice(0, 67)}</span>
                {item.text.slice(67, item.text.length - 1)}
              </p>
            )
          }
          return <p key={item.id}>{item.text}</p>
        })}
      </div>
      <Gallery />
    </section>
  )
}

export default Veranstaltungen
